import {createRoot, hydrateRoot} from 'react-dom/client';
import JoinUs from '../pages/JoinUs/JoinUs'
import "../index.css";
import "../pages/JoinUs/JoinUs.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<JoinUs {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <JoinUs {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).JoinUsVC = {mount, hydrate, unmount}